import React from 'react';

import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { DomainType } from '../../types/DomainType';
import { TestFileServerConnectionButton, TestFileServerConnectionButtonProps } from '../TestFileServerConnectionButton';
import { AddFileServerPasswordField, AddFileServerPasswordFieldProps } from './AddFileServerPasswordField';
import { AddFileServerUsernameField, AddFileServerUsernameFieldProps } from './AddFileServerUsernameField';
import { AddNewDomainDialogInformation } from './AddNewDomainDialogInformation';
import { AddNewDomainTextField, AddNewDomainTextFieldProps } from './AddNewDomainTextField';
import { AddNewFileServerDialogInformation } from './AddNewFileServerDialogInformation';
import { AddNewFileServerTextField, AddNewFileServerTextFieldProps } from './AddNewFileServerTextField';
import { DomainPermissionsSelector, DomainPermissionsSelectorProps } from './DomainPermissionsSelector';
import { DomainTypeSelector, DomainTypeSelectorProps } from './DomainTypeSelector';
import { PoolAssignmentTextProps } from './PoolAssignmentText';

export type AddNewDomainDialogBodyProps = DomainPermissionsSelectorProps & DomainTypeSelectorProps
                    & PoolAssignmentTextProps & AddNewDomainTextFieldProps& AddNewFileServerTextFieldProps
                    & AddFileServerUsernameFieldProps & AddFileServerPasswordFieldProps
                    & TestFileServerConnectionButtonProps;


export function AddNewDomainDialogBody(props: AddNewDomainDialogBodyProps) {

    return (
        <>
            { FeatureFlags.enableDataConnectFlatFile
              ? <DomainTypeSelector onDomainTypeChange={props.onDomainTypeChange} domainType={props.domainType} isEditDomainDialog={props.isEditDomainDialog} />
              : <></>
            }

            {props.domainType === DomainType.FILESERVER? <>
                <AddNewFileServerDialogInformation />
                <AddNewFileServerTextField onFilePathChange={props.onFilePathChange} filePath={props.filePath} filePathValidationStatus={props.filePathValidationStatus} />
                <AddFileServerUsernameField onUserNameChange={props.onUserNameChange} username={props.username} />
                <AddFileServerPasswordField onPasswordChange={props.onPasswordChange} password={''} isEditPassword={props.isEditPassword} />
                <TestFileServerConnectionButton onTestConnectionClicked={props.onTestConnectionClicked} testConnectionDisabled={props.testConnectionDisabled} />
            </>
              :
            <>
                <AddNewDomainDialogInformation />
                <AddNewDomainTextField onDomainNameChange={props.onDomainNameChange} domainName={props.domainName} domainValidationStatus={props.domainValidationStatus} />
            </>}
            <DomainPermissionsSelector onDomainPermissionChange={props.onDomainPermissionChange} domainPermission={props.domainPermission} />
        </>
    );
}
